<template>
  <div class="error-page">
    <div class="error-content">
      <h1>{{ error.statusCode || 500 }}</h1>
      <p class="title">{{ errorTitle }}</p>
      <p class="desc">{{ errorDescription }}</p>
      <button class="back-btn" @click="handleBack">返回首页</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const errorTitle = computed(() => {
  if (props.error.statusCode === 404) {
    return '页面未找到'
  }
  return props.error.statusMessage || '服务器内部错误'
})

const errorDescription = computed(() => {
  if (props.error.statusCode === 404) {
    return '您访问的页面不存在或已被移除，请检查链接是否正确。'
  }
  return props.error.message || '系统遇到了一点问题，请稍后重试。'
})

const handleBack = () => {
  clearError({ redirect: '/' })
}

useHead({
  title: `${errorTitle.value} - 晋百慧生物`,
  meta: [
    { name: 'description', content: errorDescription.value }
  ]
})
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
.error-content {
  text-align: center;
  padding: 2rem;
}
.error-content h1 {
  font-size: 6rem;
  font-weight: 700;
  color: #3da0e8;
  margin: 0;
  line-height: 1;
}
.title {
  font-size: 1.5rem;
  color: #333;
  margin: 1.5rem 0 0.75rem;
  font-weight: 500;
}
.desc {
  font-size: 1rem;
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.6;
}
.back-btn {
  padding: 0.75rem 2rem;
  font-size: 1rem;
  color: #fff;
  background: #3da0e8;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s ease;
}
.back-btn:hover {
  background: #2b8fd4;
}
</style>
